import { useQuery } from "@tanstack/react-query"
import { outlookIntegrationsQuery } from "modules/settings/lib/outlook/outlookIntegrationsQuery"

export function useOutlookIntegrationsQuery(...args: Parameters<typeof outlookIntegrationsQuery>) {
  return useQuery(outlookIntegrationsQuery(...args))
}
